import React, { useState } from "react";
import * as Formik from "formik";
import { Editor } from "react-draft-wysiwyg";
import Typography from "@material-ui/core/Typography";
import { ContentBlock, RawDraftContentState } from "draft-js";
import { css } from "styled-components/macro";
import Link from "./EditorComponents/Link";
import { useDebounceFunction } from "../../helpers/useDebounce";
// import { HROption } from "./EditorComponents/HROption";
// import { SpacingOption } from "./EditorComponents/SpacingOption";

// const fontOptions = ["Acronym", "TimesNow"];
// const blockTypes = ["Normal", "Blockquote"];

// const fontSizeOptions = [
//   8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 30, 34, 36, 42, 48, 60,
//   72, 96, 120, 144, 168, 192, 215, 240, 270, 302, 338, 378,
// ];

function getSimpleOption() {
  return {
    options: [
      "inline",
      "textAlign",
      // "blockType",
      // "fontSize",
      // "fontFamily",
      // "colorPicker",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    // blockType: {
    //   options: blockTypes,
    // },
    // fontFamily: {
    //   options: fontOptions,
    // },
    // fontSize: {
    //   options: fontSizeOptions,
    // },
  };
}

function getAllOptions() {
  return {
    options: [
      "inline",
      "list",
      "textAlign",
      "history",
      // "colorPicker",
      // "blockType",
      // "fontSize",
      // "fontFamily",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    // blockType: {
    //   options: blockTypes,
    // },
    // fontFamily: {
    //   options: fontOptions,
    // },
    // fontSize: {
    //   options: fontSizeOptions,
    // },
  };
}

function customBlockRenderFunc(
  rawState: RawDraftContentState,
  contentBlock: ContentBlock
) {
  if (!rawState) return contentBlock;

  return contentBlock;
}

export const PlainEditorField = React.memo(function (props: {
  label: string;
  value: RawDraftContentState;
  onChange: (state: RawDraftContentState) => void;
  simple?: boolean;
}) {
  const [state, setState] = useState<RawDraftContentState>(props.value);

  useDebounceFunction(
    () => {
      props.onChange(state);
    },
    [state],
    400
  );

  return (
    <div>
      <Typography variant="body2">{props.label}</Typography>
      <div
        css={css`
          margin-top: 10px;

          .DraftEditor-editorContainer {
            font-size: 16px;
            line-height: 1.68;
            letter-spacing: 0.02em;

            figure {
              margin: 0;
            }
          }
          .rdw-link-decorator-icon {
            display: none;
          }
          .public-DraftStyleDefault-ltr {
            text-align: inherit !important;
          }
          .public-DraftStyleDefault-block {
            margin: 0;
          }
        `}
      >
        <Editor
          initialContentState={state}
          handlePastedText={() => false}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          toolbarStyle={{
            background: "#eee",
            marginBottom: 0,
            borderRadius: "5px 5px 0 0",
          }}
          editorStyle={{
            height: 300,
            background: "#f6f6f6",
            padding: 10,
            borderRadius: "0 0 5px 5px",
            fontFamily: "Acronym",
            fontSize: 17,
            lineHeight: 1.4,
            letterSpacing: 0.05,
            color: "#2B2B2C",
          }}
          customBlockRenderFunc={customBlockRenderFunc.bind(null, state)}
          onContentStateChange={setState}
          toolbar={props.simple ? getSimpleOption() : getAllOptions()}
          toolbarCustomButtons={[
            // eslint-disable-next-line react/jsx-key
            <Link />,
            // <HROption />,
            // <SpacingOption />,
          ]}
        />
      </div>
    </div>
  );
});

export const EditorField = React.memo(function (props: {
  name: string;
  label: string;
  simple?: boolean;
}) {
  return (
    <Formik.FastField
      name={props.name}
      render={({ form, field }: Formik.FastFieldProps) => {
        const state = field.value;

        return (
          <PlainEditorField
            label={props.label}
            value={state}
            onChange={(state) => {
              form.setFieldValue(props.name, state);
            }}
            simple={props.simple}
          />
        );
      }}
    />
  );
});
